import { render, staticRenderFns } from "./HoldingShareOptionsTable.vue?vue&type=template&id=35a069e2&"
import script from "./HoldingShareOptionsTable.vue?vue&type=script&lang=js&"
export * from "./HoldingShareOptionsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports